
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as mfaiJZI6q0XTJDAY2Mu3wgrPZ8lIIkNPfvvhIjCzmom_ZMMeta } from "/home/vsts/work/1/s/pages/mfa.vue?macro=true";
import { default as homeisMk_45QriQVi8fadhACBDBK_45zKVSBVdGbYKS9msfXrMgMeta } from "/home/vsts/work/1/s/pages/home.vue?macro=true";
import { default as indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta } from "/home/vsts/work/1/s/pages/index.vue?macro=true";
import { default as oldKtBJCFS8KyzI64HknfSB_GyE0qnyuYS_45WWPJnPLIqUUMeta } from "/home/vsts/work/1/s/pages/test/old.vue?macro=true";
import { default as draweBFW5BpFSCxdHdkkVMhZdfYwHv5peYku_uvR5tlQ3gIMeta } from "/home/vsts/work/1/s/pages/test/draw.vue?macro=true";
import { default as i18nP73rgro41f0xUJTOSgwNn9snz5JivGpYg0gHvbxmc7UMeta } from "/home/vsts/work/1/s/pages/test/i18n.vue?macro=true";
import { default as indexoZ2VNxugBD6D5ypK8p0sqXMj4wZd1Y9IodFYZq9ZoAIMeta } from "/home/vsts/work/1/s/pages/test/index.vue?macro=true";
import { default as actionsWNKymns_2Swo3c4WYo05WR100JkGUqcNdfILc6xklZMMeta } from "/home/vsts/work/1/s/pages/test/actions.vue?macro=true";
import { default as indexyg8cuFnJ_45YzXRw7019UQksnOH55J8Iet7P223VsUAdYMeta } from "/home/vsts/work/1/s/pages/calendar/index.vue?macro=true";
import { default as indexnbNdVqK8t7G7KCCZN4OFkh9lN_riTdNodm1CavUEAYsMeta } from "/home/vsts/work/1/s/pages/projects/index.vue?macro=true";
import { default as materialsYdibr3_nSsaG49dhyTFxKFy_45GvalF_45UDtoOgL_RQtbgMeta } from "/home/vsts/work/1/s/pages/test/materials.vue?macro=true";
import { default as fileUploadCVRnli9ktJXEf2AaAL1bS5eMXXL8fMgstBaBVRvmTfEMeta } from "/home/vsts/work/1/s/pages/test/fileUpload.vue?macro=true";
import { default as composablesGy2Y1htj5c0qr_45pPks5d_QL61MR_F6tSHhnETXlcqj4Meta } from "/home/vsts/work/1/s/pages/test/composables.vue?macro=true";
import { default as valid_45inputs4hJUaD7DArnssNML652d1rpUyGadLRQJ4K39OaCrkpsMeta } from "/home/vsts/work/1/s/pages/test/valid-inputs.vue?macro=true";
import { default as generic_45selectsLi4bRZWrothFpLLGqzIPhVi5Hu_452s2t9oQDNHGhB6U0Meta } from "/home/vsts/work/1/s/pages/test/generic-selects.vue?macro=true";
import { default as hourRegistrationxRnAAgiDsJKmfIyq9ZJBlcP_45MlDZnadeML60C8CabHwMeta } from "/home/vsts/work/1/s/pages/test/hourRegistration.vue?macro=true";
import { default as MaterialLocationL9keCR2pnkrKnqyGQVQQz51ZlHtVleVaegmyDl7_459jQMeta } from "/home/vsts/work/1/s/pages/test/MaterialLocation.vue?macro=true";
import { default as NativeFileUpload8E5DI4fqmpn7787v2JV32tg_LTkQK6dlaByat7lCDR0Meta } from "/home/vsts/work/1/s/pages/test/NativeFileUpload.vue?macro=true";
import { default as indexESFER8sbR2RVeRs3mI474ACb4yugdu7Zvx__dntBd3YMeta } from "/home/vsts/work/1/s/pages/hourRegistrations/index.vue?macro=true";
import { default as association_45selectM94_RY07sq8dWh4KDtjZQjoJzk9EyV2vFiuB6Jx7jwwMeta } from "/home/vsts/work/1/s/pages/test/association-select.vue?macro=true";
import { default as worksheetStopwatchMxXUbAuyxQAjvyBC4a_45qqrr7k6t6q3UMCpFU1xFKTn8Meta } from "/home/vsts/work/1/s/pages/test/worksheetStopwatch.vue?macro=true";
import { default as indexPKFhkBsE6YzViincFlAH_45YLLVkzDKimrW2SQsSKKIM8Meta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/index.vue?macro=true";
import { default as notesJiXjsrLUE_hHrSWyjSIrkcJN656a3s8WnfkULWlKwmIMeta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/notes.vue?macro=true";
import { default as indexUDycRGt282SqlRcQW2mwKsQEkvFaZSmcOQe2b1JhE7UMeta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/qa/index.vue?macro=true";
import { default as _91schemaId_93ncJenRR3opOhq5NesNmoPcYCRAWBeNEtYJeHvmFPuvEMeta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/qa/[schemaId].vue?macro=true";
import { default as cartTnMToABwwq7Gu0npUzmJ94CubiYuR4uss_45_kxBUiZMsMeta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/cart.vue?macro=true";
import { default as rentFklwwXRT_hP0RY3oR6DJ8j1nyo5CqhIeCR70DOzGphoMeta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/rent.vue?macro=true";
import { default as indexC3khic1KbSIg1gL5LYn6NUi4uHwJxe5UaNPI2EcWJFUMeta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/documents/index.vue?macro=true";
import { default as itemsPKujsXFLyNG5a3QZdmsm1egpwJ54_45Uw9SpceGn2tquwMeta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/items.vue?macro=true";
import { default as catalogkEgXaf2xL5tlHHA7A_45xOtvgBEhbnz246bXQfRxqV3mwMeta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/catalog.vue?macro=true";
import { default as hour_45registrationsDF0EsaDaPsLA89qrOYemwa6LgHHNTn3oykM_45YzmGvwYMeta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/hour-registrations.vue?macro=true";
import { default as standard_45lineshpdG7KTVPXZZk2GSIGk4DbtiuKJLtJCzplZJu8J8p_458Meta } from "/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/standard-lines.vue?macro=true";
export default [
  {
    name: "mfa",
    path: "/mfa",
    component: () => import("/home/vsts/work/1/s/pages/mfa.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/home/vsts/work/1/s/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "test-old",
    path: "/test/old",
    component: () => import("/home/vsts/work/1/s/pages/test/old.vue")
  },
  {
    name: "test-draw",
    path: "/test/draw",
    component: () => import("/home/vsts/work/1/s/pages/test/draw.vue")
  },
  {
    name: "test-i18n",
    path: "/test/i18n",
    component: () => import("/home/vsts/work/1/s/pages/test/i18n.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/home/vsts/work/1/s/pages/test/index.vue")
  },
  {
    name: "test-actions",
    path: "/test/actions",
    component: () => import("/home/vsts/work/1/s/pages/test/actions.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => import("/home/vsts/work/1/s/pages/calendar/index.vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/home/vsts/work/1/s/pages/projects/index.vue")
  },
  {
    name: "test-materials",
    path: "/test/materials",
    component: () => import("/home/vsts/work/1/s/pages/test/materials.vue")
  },
  {
    name: "test-fileUpload",
    path: "/test/fileUpload",
    component: () => import("/home/vsts/work/1/s/pages/test/fileUpload.vue")
  },
  {
    name: "test-composables",
    path: "/test/composables",
    component: () => import("/home/vsts/work/1/s/pages/test/composables.vue")
  },
  {
    name: "test-valid-inputs",
    path: "/test/valid-inputs",
    component: () => import("/home/vsts/work/1/s/pages/test/valid-inputs.vue")
  },
  {
    name: "test-generic-selects",
    path: "/test/generic-selects",
    component: () => import("/home/vsts/work/1/s/pages/test/generic-selects.vue")
  },
  {
    name: "test-hourRegistration",
    path: "/test/hourRegistration",
    component: () => import("/home/vsts/work/1/s/pages/test/hourRegistration.vue")
  },
  {
    name: "test-MaterialLocation",
    path: "/test/MaterialLocation",
    component: () => import("/home/vsts/work/1/s/pages/test/MaterialLocation.vue")
  },
  {
    name: "test-NativeFileUpload",
    path: "/test/NativeFileUpload",
    component: () => import("/home/vsts/work/1/s/pages/test/NativeFileUpload.vue")
  },
  {
    name: "hourRegistrations",
    path: "/hourRegistrations",
    component: () => import("/home/vsts/work/1/s/pages/hourRegistrations/index.vue")
  },
  {
    name: "test-association-select",
    path: "/test/association-select",
    component: () => import("/home/vsts/work/1/s/pages/test/association-select.vue")
  },
  {
    name: "test-worksheetStopwatch",
    path: "/test/worksheetStopwatch",
    component: () => import("/home/vsts/work/1/s/pages/test/worksheetStopwatch.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId",
    path: "/projects/:projectId()/worksheets/:worksheetId()",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/index.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-notes",
    path: "/projects/:projectId()/worksheets/:worksheetId()/notes",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/notes.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-qa",
    path: "/projects/:projectId()/worksheets/:worksheetId()/qa",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/qa/index.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-qa-schemaId",
    path: "/projects/:projectId()/worksheets/:worksheetId()/qa/:schemaId()",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/qa/[schemaId].vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-materials-cart",
    path: "/projects/:projectId()/worksheets/:worksheetId()/materials/cart",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/cart.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-materials-rent",
    path: "/projects/:projectId()/worksheets/:worksheetId()/materials/rent",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/rent.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-documents",
    path: "/projects/:projectId()/worksheets/:worksheetId()/documents",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/documents/index.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-materials-items",
    path: "/projects/:projectId()/worksheets/:worksheetId()/materials/items",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/items.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-materials-catalog",
    path: "/projects/:projectId()/worksheets/:worksheetId()/materials/catalog",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/catalog.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-hour-registrations",
    path: "/projects/:projectId()/worksheets/:worksheetId()/hour-registrations",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/hour-registrations.vue")
  },
  {
    name: "projects-projectId-worksheets-worksheetId-materials-standard-lines",
    path: "/projects/:projectId()/worksheets/:worksheetId()/materials/standard-lines",
    component: () => import("/home/vsts/work/1/s/pages/projects/[projectId]/worksheets/[worksheetId]/materials/standard-lines.vue")
  }
]